import React, { Suspense } from 'react'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'

import type { RouterContext } from '@/app/router'
import { Toaster } from '@/components/ui/sonner'

const TanStackDevtools = import.meta.env.DEV
  ? React.lazy(() =>
      import('@tanstack/react-devtools').then((mod) => ({
        default: mod.TanStackDevtools,
      })),
    )
  : () => null

const TanStackRouterDevtoolsPanel = import.meta.env.DEV
  ? React.lazy(() =>
      import('@tanstack/react-router-devtools').then((mod) => ({
        default: mod.TanStackRouterDevtoolsPanel,
      })),
    )
  : () => null

const ReactQueryDevtoolsPanel = import.meta.env.DEV
  ? React.lazy(() =>
      import('@tanstack/react-query-devtools').then((mod) => ({
        default: mod.ReactQueryDevtoolsPanel,
      })),
    )
  : () => null

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  return (
    <>
      <Outlet />
      <Toaster />
      <Suspense fallback={null}>
        <TanStackDevtools
          config={{
            position: 'bottom-right',
          }}
          plugins={[
            {
              name: 'Tanstack Router',
              render: <TanStackRouterDevtoolsPanel />,
            },
            {
              name: 'React Query',
              render: <ReactQueryDevtoolsPanel />,
            },
          ]}
        />
      </Suspense>
    </>
  )
}
